module.exports = function(bootstrap) {
    bootstrap.run(["Service","sessionData", function (Service, sessionData) {
        return new Service({

            name: 'idcardMembers',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/idcard/v1/members",

            fetch: function(umi){
                var params = {
                    umi: umi
                }
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
                return this.get(params);
            }
        });
    }]);
};
